import React from "react";
import { IonItem, IonLabel, IonAccordion } from "@ionic/react";

export interface Props {}

const TroubleShootingHelp: React.FC<Props> = () => {
  return (
    <IonAccordion value="TroubleShootingHelp">
      <IonItem slot="header" color="light">
        <IonLabel>Troubleshooting</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <ul>
          <li>
            Can&rsquo;t cast &ndash;{" "}
            <ol>
              <li>
                Test that you are on the same wiifi network as your Chromecast
                and that the signal strength is adequate (e.g. try browsing a
                web page);
              </li>
              <li>Log Out of the app, then resume;</li>
              <li>
                Use the Google Home app to ensure your Chromecast is available.
              </li>
            </ol>
          </li>
          <li>
            Screen freezes &ndash; your screen may be cached during a brief
            wi-fi disruption.
            <ol>
              <li>
                Wait for the wi-fi to recover, then resume. You may need to
                reselect the Chromecast code;
              </li>
              <li>
                Try to prompt the screen; using the Rounds/Prizes/Teams buttons
                during the Intro cycle, or by using the Search button during the
                quiz;
              </li>
              <li>
                Refresh the screen by using the Cast icon to stop and start
                casting;
              </li>
              <li>
                Use the &apos;Clear Cache&apos; option under Tools to reset the
                quiz. Log back in and resume. Your quiz data will be retained.
              </li>
              <li>
                Briefly unplug the USB end of your Chromecast to de-power the
                screen, then resume using the Cast icon.
              </li>
            </ol>
            <b>Please note:</b> you can log out of the app, log back in, and
            resume your quiz at any time.
          </li>
          <li>
            Questions are out of alignment &ndash; use the Search function to
            realign the question on the app to the details on the tv screen.
          </li>
          <li>
            Exit app &ndash; if you accidentally log out or close the app (by
            using the power button, or the tablet&rsquo;s back button) simply
            log back in, cast, then press &lsquo;Continue Quiz&rsquo; to resume
            your quiz.
          </li>
        </ul>
      </div>
    </IonAccordion>
  );
};

export default TroubleShootingHelp;
